// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__gn70a","subheader":"ReorderModal_subheader__1Pqb9","listWrap":"ReorderModal_listWrap__a7TbZ"};